import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { FONT_SIZE } from "../../constants/Constants";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setSelectedFontSizeForShape } from "../../reducers/markup-reducer";
import { onPasteValidate, setMarkupFontSize, validateInput } from "./MarkupFunction";
import { UPLOAD_FILES_DATA } from "../../constants/UploadFilesConstants";
import { PublicVariables } from "../../constants/PublicVariables";

const MarkupFontDropdown = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { selectedFontSizeForShape } = useSelector((state) => state.markup);
    const [fontSize, setFontSize] = useState(UPLOAD_FILES_DATA.selectedImageObj?.selectedFontSize || "");
    const [isInputChanged, setIsInputChanged] = useState(false);

    const setFontSizeForImage = (selectedFontSize) => {
        if (UPLOAD_FILES_DATA.selectedImageObj) {
            UPLOAD_FILES_DATA.selectedImageObj.selectedFontSize = selectedFontSize;
        }
    };

    const fontSizeChangeHandler = (fontSizeValue) => {
        // Avoid setting if the value is the same
        if (fontSize !== fontSizeValue) {
            setFontSize(fontSizeValue);
            setFontSizeForImage(fontSizeValue);
            const newFontSize = Math.min(Math.max(fontSizeValue, FONT_SIZE[0]), FONT_SIZE[FONT_SIZE.length - 1]);
            dispatch(setSelectedFontSizeForShape(newFontSize));
        }
    };

    const handleToSetFontSizeOnBlur = (selectedFontSize) => {
        const newFontSize = Math.min(Math.max(selectedFontSize, FONT_SIZE[0]), FONT_SIZE[FONT_SIZE.length - 1]);
        setFontSize(newFontSize);
        setFontSizeForImage(newFontSize);
        setIsInputChanged(false);
    };

    useEffect(() => {
        if (selectedFontSizeForShape) {
            if (!isInputChanged) {
                fontSizeChangeHandler(selectedFontSizeForShape);
            }
        }
    }, [selectedFontSizeForShape]);

    const fontSizeHTML = FONT_SIZE.map((fontSize) => (
        <li key={fontSize}>
            <div className='dropdown-item-div'>
                <button
                    className={clsx("dropdown-item dropdown-item-fonts-btn", selectedFontSizeForShape === fontSize && "active")}
                    onClick={() => setMarkupFontSize(fontSize)}
                >
                    <span className='for-text'>{fontSize}</span>
                </button>
            </div>
        </li>
    ));

    return (
        <div className='markup-menu-item-in markup-fonts-box'>
            <div className='left-text'>{localisedValues?.font_label}</div>
            <div className='markup-common-dropdown markup-fonts-dropdown dropdown'>
                <input
                    type='text'
                    className='form-control font-form-control'
                    value={fontSize}
                    id='markup-fonts-dropdown'
                    autoComplete='off'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                    onChange={(e) => {
                        setIsInputChanged(true);
                        fontSizeChangeHandler(e.target.value);
                    }}
                    onPaste={(e) => onPasteValidate(e)}
                    onKeyDown={(e) => validateInput(e)}
                    onBlur={(e) => {
                        handleToSetFontSizeOnBlur(e.target.value);
                    }}
                    style={{ fontSize: PublicVariables.isIOSDevice ? "16px" : "" }}
                    onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    inputMode='numeric'
                    pattern='[0-9]*'
                />
                <span className='font-border'></span>
                <div className='dropdown-menu markup-common-dropdown-menu' aria-labelledby='markup-fonts-dropdown'>
                    <div className='dropdown-menu-in'>
                        <ul className='dropdown-scroll custom-scroll-thin'>{fontSizeHTML}</ul>
                    </div>
                </div>
            </div>
            <div className='right-text'>px</div>
        </div>
    );
};

export default MarkupFontDropdown;
